import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_ARTIST_SET = gql`
  query getArtistSet($name: String!) {
    getArtistSet(name: $name) {
        artistSetSlugName
    }
  }
`;

const getArtistSet = async (name = '') => {
  try {
    const result = await client
      .query({
        query: GET_ARTIST_SET,
        errorPolicy: 'all',
        fetchResults: true,
        fetchPolicy: 'no-cache',
        variables: { name },
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { getArtistSet: artistSetData },
    } = result;

    if (artistSetData) {
      return artistSetData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getArtistSet = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getArtistSet Error: ${error}`);
    return null;
  }
};

export default getArtistSet;
